// Check if we're editing a cart item
const urlParams = new URLSearchParams(window.location.search);
const editCartItemKey = urlParams.get('edit_cart_item');
const editQty = parseInt(urlParams.get('qty')) || 1;

// Function to set quantity and button text
function setEditModeUI() {
  if (!editCartItemKey || !editQty) return;

  // Find and set quantity inputs
  const allQtyInputs = document.querySelectorAll('input[name="quantity"], .quantity-input');

  if (allQtyInputs.length === 0) {
    // Try alternative selectors
    const altInputs = document.querySelectorAll('input[type="number"]');
    altInputs.forEach(input => {
      if (input.name === 'quantity' || input.classList.contains('quantity-input')) {
        input.value = editQty;
      }
    });
  } else {
    allQtyInputs.forEach(input => {
      input.value = editQty;
    });
  }

  // Update button text to 'Update cart'
  const addToCartBtns = document.querySelectorAll('.add-to-cart-btn');
  addToCartBtns.forEach(btn => {
    btn.textContent = 'Update cart';
  });
}

// Try multiple times to ensure we catch the elements
if (editCartItemKey) {
  // Try immediately
  setEditModeUI();

  // Try after 100ms
  setTimeout(setEditModeUI, 100);

  // Try after 500ms
  setTimeout(setEditModeUI, 500);
}

document.addEventListener('DOMContentLoaded', function () {
    // Try again on DOMContentLoaded
    if (editCartItemKey) {
      setTimeout(setEditModeUI, 50);
    }

    document.querySelectorAll('.product-form').forEach((productSection) => {
      const form = productSection.querySelector('form');
      if (!form) return;

      const variantPicker = form.querySelector('.product-variant-picker');
      if (!variantPicker) return;

      const productJsonEl = form.querySelector('[id^="ProductJson-"]');
      if (!productJsonEl) return;

      const productDataRaw = JSON.parse(productJsonEl.textContent);
      const variants = productDataRaw.variants ? productDataRaw.variants : productDataRaw;
      const variantInput = form.querySelector('input[name="id"]');
      const addToCartBtn = form.querySelector('.add-to-cart-btn');
      const priceEl = form.querySelector('.product-price');
      const finalPriceEl = form.querySelector('.product-final-price');

      let isProgrammaticChange = false;
  
      function waitForHulkTotal() {

        const existing = document.querySelector('#calculated_option_total');
        if (existing) {
          attachHulkObserver(existing);
          return;
        }
      
        const tempObserver = new MutationObserver(() => {
          const el = document.querySelector('#calculated_option_total');
          if (el) {
            tempObserver.disconnect();
            attachHulkObserver(el);
          }
        });
      
        tempObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      function attachHulkObserver(calculatedEl) {
      
        const hulkObserver = new MutationObserver(() => {
      
          const variantId = variantInput.value;
          const variant = variants.find(v => v.id == variantId);
      
          if (variant) {
            updateFinalPrice(variant);
          }
      
        });
      
        hulkObserver.observe(calculatedEl, {
          childList: true,
          characterData: true,
          subtree: true
        });
      
      }
      
      waitForHulkTotal();


      function updateVariantId() {
        const isDefault = variantPicker.querySelectorAll('.variant-group').length === 0;
        if (isDefault) return;
        const selectedOptions = Array.from(
          variantPicker.querySelectorAll('.variant-group')
        ).map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
  
        const variant = variants.find(
          (v) => v.options.every((opt, i) => opt === selectedOptions[i])
        );
  
        if (variant) {
          variantInput.value = variant.id;
          updateFinalPrice(variant);
          updateSelectedOptionLabels();
          slideToVariantImage(variant);
          addToCartBtn.disabled = !variant.available;
        } else {
          variantInput.value = '';
          addToCartBtn.disabled = true;
        }
      }
  
      function updateSelectedOptionLabels() {
        variantPicker.querySelectorAll('.variant-group').forEach((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          const valueEl = fieldset.querySelector('.variant-selected-value');
          if (checked && valueEl) valueEl.textContent = checked.value;
        });
      }
  
      function updateOptions() {
        if (isProgrammaticChange) return;
  
        const fieldsets = variantPicker.querySelectorAll('.variant-group');
        if (fieldsets.length === 0) return;
        const selected = Array.from(fieldsets).map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
  
        fieldsets.forEach((fs, index) => {
          if (index === 0) return; 
          const inputs = fs.querySelectorAll('input');
          let firstAvailable = null;
  
          inputs.forEach((input) => {
            const canCombine = variants.some(
              (v) => v.available && v.options[0] === selected[0] && v.options[index] === input.value
            );
  
            input.disabled = !canCombine;
            input.nextElementSibling.style.display = canCombine ? 'inline-block' : 'none';
  
            if (canCombine && !firstAvailable) firstAvailable = input;
          });
  
          const checked = fs.querySelector('input:checked');
          if (!checked || checked.disabled) {
            if (firstAvailable) {
              isProgrammaticChange = true;
              firstAvailable.checked = true;
              firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
              isProgrammaticChange = false;
            }
          }
        });
  
        updateVariantId();
      }
  
      function updatePrimaryOptionAvailability() {
        const primaryFieldset = variantPicker.querySelector('.variant-group[data-option-index="0"]');
        if (!primaryFieldset) return;
  
        primaryFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          const hasAvailableVariant = variants.some(
            (v) => v.available && v.options[0] === input.value
          );
          input.disabled = !hasAvailableVariant;
          input.nextElementSibling.classList.toggle('is-sold-out', !hasAvailableVariant);
        });
      }
  
      function slideToVariantImage(variant) {
        if (!variant || !variant.featured_image || !window.productSwiper) return;
        const imageId = variant.featured_image.id;
        const slides = document.querySelectorAll('.product-swiper .swiper-slide');
        slides.forEach((slide, index) => {
          if (slide.dataset.imageId == imageId) window.productSwiper.slideTo(index);
        });
      }
      
      function updateFinalPrice(variant) {
        if (!variant || !finalPriceEl) return;
      
        const format = priceEl.dataset.currencyFormat;
        const basePrice = variant.price;
      
        let hulkTotal = 0;
        const calculatedEl = document.querySelector('#calculated_option_total');
      
        if (calculatedEl) {
          hulkTotal = parseFloat(calculatedEl.textContent.replace(',', '.')) * 100;
        }
      
        const total = basePrice + hulkTotal;
      
        finalPriceEl.textContent = formatMoney(total);
      }
      
      function formatMoney(cents) {
        const currencyCode = window.Shopify?.currency?.active || 'GBP';
        const locale = window.Shopify?.locale || 'en-GB';
    
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
        }).format(cents / 100);
    }

      

      variantPicker.addEventListener('change', updateOptions);

      updatePrimaryOptionAvailability();
      updateOptions();

      // Some third-party product-option apps (e.g. Hulk Product Options) re-enable
      // the add-to-cart button once their own required fields are satisfied,
      // without knowing whether the selected Shopify variant is actually in stock.
      // Force the button back to disabled whenever that happens for a sold-out variant.
      function isSelectedVariantAvailable() {
        const fieldsets = variantPicker.querySelectorAll('.variant-group');
        let variant;
        if (fieldsets.length === 0) {
          variant = variants[0];
        } else {
          const selectedOptions = Array.from(fieldsets).map((fs) => {
            const checked = fs.querySelector('input:checked');
            return checked ? checked.value : null;
          });
          variant = variants.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
        }
        return !!(variant && variant.available);
      }

      new MutationObserver(() => {
        if (!addToCartBtn.disabled && !isSelectedVariantAvailable()) {
          addToCartBtn.disabled = true;
        }
      }).observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
    });
  });
  (function(){

    function initAccordion() {
  
      const wrapper = document.querySelector('.hulkapps_option_set');
      if (!wrapper) return false;
  
      if (wrapper.querySelector('.hulk-group')) return true;
  
      const groups = {
        "Jacket Size": ['jacket_size'],
        "Sizing": ['height','body_length','bicep','chest','hem','waist','hips','sleeve_length'],
        "Linings and Zip": ['jacket_body_lining','sleeve_lining','zipper_tape_colour'],
        "Options": []
      };
  
      const allOptions = [...wrapper.querySelectorAll('.hulkapps_option')];
      allOptions.forEach(opt => opt.style.display = 'none');
  
      allOptions.forEach(opt => wrapper.removeChild(opt));
  
      Object.entries(groups).forEach(([title, keys]) => {
  
        const matches = allOptions.filter(opt => {
          const id = opt.id?.toLowerCase();
          if (!id) return false;
  
          return keys.includes(id) ||
            (title === "Options" && !Object.values(groups).flat().includes(id));
        });
  
        // Only show sections that have fields for this product
        if (matches.length === 0) return;
  
        const groupDiv = document.createElement('div');
        groupDiv.className = 'hulk-group';
  
        const heading = document.createElement('div');
        heading.className = 'hulk-group-title';
        heading.innerText = title;
  
        const content = document.createElement('div');
        content.className = 'hulk-group-content';
  
        groupDiv.appendChild(heading);
        groupDiv.appendChild(content);
  
        wrapper.appendChild(groupDiv);
  
        matches.forEach(opt => {
          content.appendChild(opt);
          opt.style.display = 'block';
        });
  
      });
  
      wrapper.querySelectorAll('.hulk-group-title').forEach(title => {
        title.addEventListener('click', () => {
      
          const group = title.parentElement;
          const content = group.querySelector('.hulk-group-content');
          const allContents = group.parentElement.querySelectorAll('.hulk-group-content');
      
          allContents.forEach(c => {
            if (c !== content) {
              c.style.maxHeight = null;
              c.parentElement.classList.remove('active');
            }
          });
      
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
            group.classList.remove('active');
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
            group.classList.add('active');
          }
      
        });
      });
  
      return true;
    }

    function moveTotalBelowHulk() {
        const hulkWrapper = document.querySelector('.hulkapps_option_set');
        const totalPrice = document.getElementById('ProductTotal');

        if (hulkWrapper && totalPrice) {
          hulkWrapper.insertAdjacentElement('afterend', totalPrice);
        }
      }

    // The Custom Ordering / sizing guide link is only relevant for
    // made-to-measure jackets with Hulk custom options, so it's hidden
    // (display:none in the markup) by default and only revealed once we've
    // confirmed Hulk options actually exist for this product — that way
    // products without options (e.g. gloves) never show it at all, instead
    // of showing it and then yanking it away once Hulk fails to appear.
    function showCustomOrdering() {
      const customOrdering = document.querySelector('#custom-ordering');
      if (customOrdering) customOrdering.style.display = '';
    }

    if (initAccordion()) {
        showCustomOrdering();
        moveTotalBelowHulk();
        return;
    }


    window.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(() => {
            if (initAccordion()) {
                showCustomOrdering();
                moveTotalBelowHulk();
                observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          document.querySelectorAll('.gpsr-attribute-title').forEach(title => {
            title.addEventListener('click', () => {
              const isActive = title.classList.contains('active');
              document.querySelectorAll('.gpsr-attribute-title').forEach(t => t.classList.remove('active'));
              document.querySelectorAll('.gpsr-attribute-context').forEach(c => c.classList.remove('active'));
              if (!isActive) {
                title.classList.add('active');
                title.nextElementSibling.classList.add('active');
              }
            });
          });
      });
  
  })();
  function openGroupsWithErrors() {
    const groups = document.querySelectorAll('.hulk-group');
  
    groups.forEach(group => {
      const content = group.querySelector('.hulk-group-content');
  
      const hasError =
        content.querySelector('.validation_error');
  
      if (hasError) {
        content.style.maxHeight = content.scrollHeight + "px";
        group.classList.add('active');
      }
    });
  }
  
  document.addEventListener('click', function(e) {

    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;

    setTimeout(() => {
      openGroupsWithErrors();
    }, 200);

  });

  // Jacket configurator (Hulk product options) tracking
  (function () {
    let configuratorStarted = false;
    let configuratorCompleted = false;

    // Every required Hulk field carries a required class on its wrapper and
    // a hidden properties[...] input that Hulk fills in once a value is
    // chosen — this is the same mechanism regardless of field type
    // (dropdown, radio, swatch, text), so it's a reliable "is this field
    // answered" check without needing to know each field type's markup.
    function allRequiredOptionsFilled() {
      const requiredFields = document.querySelectorAll('.hulkapps_option.required');
      if (requiredFields.length === 0) return false;
      return Array.from(requiredFields).every(function (field) {
        const hiddenInput = field.querySelector('input[type="hidden"][name^="properties["]');
        return hiddenInput && hiddenInput.value.trim() !== '';
      });
    }

    document.addEventListener('change', function (e) {
      if (!e.target.closest('.hulkapps_option_set')) return;

      if (!configuratorStarted) {
        configuratorStarted = true;
        if (window.Analytics) window.Analytics.pushEvent('configurator_started');
      }

      if (configuratorCompleted) return;
      // Hulk updates its hidden properties[...] input right after its own
      // change handler runs, so check on the next tick instead of reading it
      // synchronously within this same event.
      setTimeout(function () {
        if (configuratorCompleted) return;
        if (allRequiredOptionsFilled()) {
          configuratorCompleted = true;
          if (window.Analytics) window.Analytics.pushEvent('configurator_completed');
        }
      }, 50);
    });
  })();
